import { RG_TYPE as o, DOOR_TYPE as t } from "@project-rouge/rg-core";
const i = (r) => r.type !== o.Door ? !1 : r.data.doorType === t.Misc;
export {
  i as isMiscDoor
};
//# sourceMappingURL=index6.js.map
